import { Component, HostListener, Input } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
isShown: any;
isCollapsed: boolean = false;
  constructor(private adminService:ServiceService,private breakpointObserver: BreakpointObserver,private route: ActivatedRoute, private router: Router) {}



  Message="";
  Sucess=false;
  tempCollapse: boolean = false
  
  Notification=false
  loaderShown=false
  //ManualSyc="http://192.241.151.66:5000/manualSyncdb"
 //-----------------function for zinc data base-------------------------------
  ZincDB(){
    this.loaderShown=true;
    this.adminService.DataSync().subscribe((res)=>{
       this.Sucess=res.sucess
       if(this.Sucess){
        this.Message="Successfully Synchronized"
       }
       else{
        this.Message="Failed"
       }
       this.loaderShown=false;
       this.Notification=true
       setTimeout(() => {
        this.Notification=false
    }, 1500);
       })
/*
        this.loaderShown=true; 
        setTimeout(() => {
          this.loaderShown=false; 
        }, 1000);

       setTimeout(() => {
         this.Notification=true
     }, 1050);
*/
      
        
       
  }
  ngOnInit() {
  

   // this.router.navigate(['employee-management'], {relativeTo:this.route});
  }
//---function for logout------

//for showing dashboard


mouseEnter() {              // mouse hover side panel
  if (!this.isCollapsed) {
    this.tempCollapse = true
    this.isCollapsed = true
  }
  else {
    this.tempCollapse = false
    this.isCollapsed = true
  }
}

mouseLeave() {                // mouse hover side panel
  if (!this.tempCollapse) {
    this.isCollapsed = true
  }
  else {
    this.isCollapsed = false
  }
}

@HostListener('window:resize', ['$event'])      //window screen size event
onResize(event: any) {
  this.isCollapsed = window.innerWidth > 928;
}

}
